import axios from "axios";
import { SET_LOADING, SET_TEACHER_APPLICATIONS } from "./types";

export const fetchTeacherApplications = () => async (dispatch) => {
  dispatch({ type: SET_LOADING });

  const res = await axios.get(
    `${process.env.REACT_APP_API_URL}/api/teachers/teacherDetails`
  );

  dispatch({
    type: SET_TEACHER_APPLICATIONS,
    payload: res.data,
  });
};
export const approveTeacher = (teacherId) => async (dispatch) => {
  await axios.post(
    `${process.env.REACT_APP_API_URL}/api/teachers/approve/${teacherId}`
  );
  dispatch(fetchTeacherApplications());
};

export const setTeacherPending = (teacherId) => async (dispatch) => {
  await axios.post(
    `${process.env.REACT_APP_API_URL}/api/teachers/set-pending/${teacherId}`
  );
  dispatch(fetchTeacherApplications());
};

// Blob download
// Blob download with teacher's name
export const downloadTeacherCv = (teacherId, firstName, lastName) => async () => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/teachers/cv/${teacherId}`,
      { responseType: 'blob' }
    );

    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement('a');
    const safeFirstName = firstName.replace(/\s+/g, '_');
    const safeLastName = lastName.replace(/\s+/g, '_');

    link.href = url;
    link.setAttribute('download', `CV_${safeFirstName}_${safeLastName}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (error) {
    console.error("Download failed:", error);
  }
};

// teacherManagerActions.js
export const downloadTeacherCertificate = (teacherId, firstName, lastName) => async () => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/teachers/certificate/${teacherId}`,
      { responseType: 'blob' }
    );
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement('a');
    const safeFirst = (firstName || '').replace(/\s+/g, '_');
    const safeLast  = (lastName  || '').replace(/\s+/g, '_');
    link.href = url;
    link.setAttribute('download', `Certificate_${safeFirst}_${safeLast}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (error) {
    console.error("Certificate download failed:", error);
  }
};


// teacherManagerActions.js
export const sendInterviewEmail = (teacherId, zoomLink, message) => async (dispatch) => {
  await axios.post(`${process.env.REACT_APP_API_URL}/api/teachers/${teacherId}/notify/interview`, {
    zoomLink,
    message
  });
  dispatch(fetchTeacherApplications());
};

export const sendRefusalEmail = (teacherId, message) => async (dispatch) => {
  await axios.post(`${process.env.REACT_APP_API_URL}/api/teachers/${teacherId}/notify/refusal`, {
    message
  });
  dispatch(fetchTeacherApplications());
};
